module.exports = __webpack_public_path__ + "static/media/dumbbell.f324a044.svg";